<div class="row user-col2">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body" style="padding:20px;">
                <div style="display: flex;cursor:pointer">
                    <input (keyup)="searchEnter($event)" [(ngModel)]="email" class="form-control" placeholder="Search by email address" type="text" style="background-color:white; border-radius: 30px;">
                </div>
            </div>
        </div>
    </div>

    <div class="col-sm-12">
        <div class="card" style="border-radius:10px" *ngFor="let user of users; let i = index">
            <div class="card-body" style="padding:20px; border-radius:5px">
                <div style="display: flex;">
                    <img class="rounded-circle image-radius m-r-15"
                         [src]="user.contactLogo" alt="" style="border-radius: 50% !important; height: 50px; width: 50px;">
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="row">
                                <div class="col-xl-12" style="font-size: 10px">
                                    {{user.id}}
                                </div>
                                <div class="col-xl-12" style="color: #0076c8;">
                                    <b>{{user.firstName}} {{user.lastName}}</b>
                                    <span *ngIf="!user.isActive" style="color: red;"> (Inactive)</span>
                                    <a (click)="activateDeactivateUser('1', user)" *ngIf="!user.isActive" style="color: green;cursor:pointer"> Activate user</a>

                                    <span *ngIf="user.isActive" style="color: green;"> (Active)</span>
                                    <a (click)="activateDeactivateUser('0', user)" *ngIf="user.isActive" style="color: red;cursor: pointer"> Deactivate user</a>
                                </div>
                                <div class="col-xl-12" style="color: brown;">
                                    {{user.eMail}}
                                </div>
                                <div class="col-xl-12" style="color: blue;">
                                    {{user.mobilePhone}}
                                </div>
                                <div class="col-xl-12">
                                    {{user.title}}
                                </div>
                                <div class="col-xl-12">
                                    {{user.portalAccount.name}}
                                </div>
                                <div class="col-xl-12" style="opacity:.5">
                                    Registration date: {{user.createdDate | date:'medium'}}
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-xl-6">
                            
                        </div>
                       
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </div>
</div>
